export const TimeDuration = [
  {
    'label': '3 months',
    'value': '3 months'
  },
  {
    'label': '6 months',
    'value': '6 months'
  },
  {
    'label': '9 months',
    'value': '9 months'
  },
  {
    'label': '12 months',
    'value': '12 months'
  }
];
